// Keys used by the app that were missing from translations.js.
// They are merged in without overwriting existing values (see ./index.js).

const en = {
  adminPage: {
    roles: { student: "Student" },
    dashboard: {
      examsSubmissions: "results",
      examsEmpty: "No scored tests yet.",
      thisMonthShort: "this month",
    },
    users: { noAccount: "No account" },
    students: {
      deleteConfirm: "Delete {{name}}? Their lessons, homework and results will be deleted too.",
    },
    classEditor: {
      subtitle: "Drag students from the list on the right into the class, or use the + button.",
      inClass: "Students in this class",
      available: "All students",
      search: "Search a student or parent email",
      dropHint: "Drag students here to add them to the class.",
      noResults: "No student matches this search.",
      allAdded: "Every student is already in this class.",
      add: "Add",
      remove: "Remove",
      noClasses: "No classes yet. Create the first one above.",
    },
    teacherHours: {
      title: "Teaching hours",
      subtitle: "Hours per teacher for the selected period (group sessions count once, cancelled ones are excluded).",
      today: "Today",
      month: "This month",
      custom: "Custom",
      from: "From",
      to: "To",
      teacher: "Teacher",
      sessions: "Sessions",
      done: "Taught",
      planned: "Planned",
      total: "Total",
      hoursShort: "h",
      empty: "No teachers yet.",
    },
  },
  common: { loading: "Loading..." },
  sidebar: {
    sections: {
      main: "Main menu",
      management: "Academic management",
      other: "Other menu",
    },
  },
  authPage: {
    back: "Back",
    newPassword: "New password",
    otp: "OTP code",
    otpPlaceholder: "Enter the 6-digit code",
    otpRequired: "OTP code is required.",
    passwordMismatch: "Passwords do not match.",
    passwordRequired: "New password is required.",
    resetCta: "Reset password",
    resetLead: "Choose a new password for your account.",
    resetTitle: "Reset password",
    verifyCta: "Verify code",
  },
  homeworks: {
    status: { draft: "Draft", published: "Published", archived: "Archived" },
    common: { loading: "Loading...", open: "Open", viewAll: "View all" },
    student: {
      due: "Due: {{date}}",
      empty: "No homeworks assigned yet.",
      noDue: "No due date",
      subtitle: "See your assigned homeworks.",
    },
  },
};

const fr = {
  adminPage: {
    roles: { student: "Élève" },
    dashboard: {
      examsSubmissions: "résultats",
      examsEmpty: "Aucun test noté pour le moment.",
      thisMonthShort: "ce mois",
    },
    users: { noAccount: "Pas de compte" },
    students: {
      deleteConfirm: "Supprimer {{name}} ? Ses cours, devoirs et résultats seront aussi supprimés.",
    },
    classEditor: {
      subtitle: "Glissez les élèves de la liste de droite vers la classe, ou utilisez le bouton +.",
      inClass: "Élèves de la classe",
      available: "Tous les élèves",
      search: "Rechercher un élève ou l'e-mail d'un parent",
      dropHint: "Glissez des élèves ici pour les ajouter à la classe.",
      noResults: "Aucun élève ne correspond à cette recherche.",
      allAdded: "Tous les élèves sont déjà dans cette classe.",
      add: "Ajouter",
      remove: "Retirer",
      noClasses: "Aucune classe pour le moment. Créez la première ci-dessus.",
    },
    teacherHours: {
      title: "Heures des enseignants",
      subtitle: "Heures par enseignant sur la période choisie (une séance de groupe compte une fois, les séances annulées sont exclues).",
      today: "Aujourd'hui",
      month: "Ce mois",
      custom: "Personnalisé",
      from: "Du",
      to: "Au",
      teacher: "Enseignant",
      sessions: "Séances",
      done: "Effectuées",
      planned: "Planifiées",
      total: "Total",
      hoursShort: "h",
      empty: "Aucun enseignant pour le moment.",
    },
  },
  common: { loading: "Chargement..." },
  sidebar: {
    sections: {
      main: "Menu principal",
      management: "Gestion pédagogique",
      other: "Autres",
    },
  },
  authPage: {
    back: "Retour",
    newPassword: "Nouveau mot de passe",
    otp: "Code de vérification",
    otpPlaceholder: "Saisissez le code à 6 chiffres",
    otpRequired: "Le code de vérification est requis.",
    passwordMismatch: "Les mots de passe ne correspondent pas.",
    passwordRequired: "Le nouveau mot de passe est requis.",
    resetCta: "Réinitialiser le mot de passe",
    resetLead: "Choisissez un nouveau mot de passe pour votre compte.",
    resetTitle: "Réinitialiser le mot de passe",
    verifyCta: "Vérifier le code",
  },
  homeworks: {
    status: { draft: "Brouillon", published: "Publié", archived: "Archivé" },
    common: { loading: "Chargement...", open: "Ouvrir", viewAll: "Tout voir" },
    student: {
      due: "À rendre le {{date}}",
      empty: "Aucun devoir pour le moment.",
      noDue: "Pas de date limite",
      subtitle: "Retrouvez les devoirs qui vous sont assignés.",
    },
  },
};

const ar = {
  adminPage: {
    roles: { student: "تلميذ" },
    dashboard: {
      examsSubmissions: "نتيجة",
      examsEmpty: "لا توجد اختبارات مصحّحة بعد.",
      thisMonthShort: "هذا الشهر",
    },
    users: { noAccount: "بدون حساب" },
    students: {
      deleteConfirm: "حذف {{name}}؟ ستُحذف أيضاً حصصه وواجباته ونتائجه.",
    },
    classEditor: {
      subtitle: "اسحب التلاميذ من القائمة على اليمين إلى القسم، أو استعمل زرّ +.",
      inClass: "تلاميذ هذا القسم",
      available: "كلّ التلاميذ",
      search: "ابحث عن تلميذ أو بريد وليّ",
      dropHint: "اسحب التلاميذ إلى هنا لإضافتهم إلى القسم.",
      noResults: "لا يوجد تلميذ يطابق هذا البحث.",
      allAdded: "كلّ التلاميذ موجودون في هذا القسم.",
      add: "إضافة",
      remove: "إزالة",
      noClasses: "لا توجد أقسام بعد. أنشئ القسم الأوّل أعلاه.",
    },
    teacherHours: {
      title: "ساعات المعلّمين",
      subtitle: "عدد الساعات لكلّ معلّم خلال الفترة المختارة (الحصّة الجماعية تُحتسب مرّة واحدة، والحصص الملغاة غير محتسبة).",
      today: "اليوم",
      month: "هذا الشهر",
      custom: "فترة مخصّصة",
      from: "من",
      to: "إلى",
      teacher: "المعلّم",
      sessions: "الحصص",
      done: "المنجزة",
      planned: "المبرمجة",
      total: "المجموع",
      hoursShort: "س",
      empty: "لا يوجد معلّمون بعد.",
    },
  },
  common: { loading: "جارٍ التحميل..." },
  authPage: {
    back: "رجوع",
    newPassword: "كلمة المرور الجديدة",
    otp: "رمز التحقق",
    otpPlaceholder: "أدخل الرمز المكوّن من 6 أرقام",
    otpRequired: "رمز التحقق مطلوب.",
    passwordMismatch: "كلمتا المرور غير متطابقتين.",
    passwordRequired: "كلمة المرور الجديدة مطلوبة.",
    resetCta: "إعادة تعيين كلمة المرور",
    resetLead: "اختر كلمة مرور جديدة لحسابك.",
    resetTitle: "إعادة تعيين كلمة المرور",
    verifyCta: "تحقّق من الرمز",
  },
  homeworks: {
    status: { draft: "مسودّة", published: "منشور", archived: "مؤرشف" },
    common: { loading: "جارٍ التحميل...", open: "فتح", viewAll: "عرض الكل" },
    student: {
      due: "آخر أجل: {{date}}",
      empty: "لا توجد واجبات حالياً.",
      noDue: "بدون آخر أجل",
      subtitle: "اطّلع على الواجبات المسندة إليك.",
    },
  },
};

// Homework screens (they previously only had English fallbacks).
const frModules = {
  homeworks: {
    common: {
      add: "Ajouter",
      adding: "Ajout...",
      config: "Configuration (JSON)",
      create: "Créer",
      creating: "Création...",
      delete: "Supprimer",
      description: "Description",
      dueAt: "À rendre le",
      edit: "Modifier",
      failedLoad: "Impossible de charger les devoirs",
      leave: "Quitter",
      order: "Ordre",
      points: "Points",
      preview: "Aperçu",
      prompt: "Consigne",
      save: "Enregistrer",
      saving: "Enregistrement...",
      status: "Statut",
      submit: "Envoyer",
      submitting: "Envoi...",
      title: "Devoirs",
      titleLabel: "Titre",
      type: "Type",
    },
    editor: {
      addExercise: "Ajouter un exercice",
      confirmDeleteExercise: "Supprimer cet exercice ?",
      details: "Détails",
      exercises: "Exercices",
      failedAddExercise: "Impossible d'ajouter l'exercice",
      failedDeleteExercise: "Impossible de supprimer l'exercice",
      failedLoad: "Impossible de charger le devoir",
      failedSave: "Impossible d'enregistrer le devoir",
      failedSaveExercise: "Impossible d'enregistrer l'exercice",
      invalidJson: "La configuration JSON est invalide.",
      noExercises: "Aucun exercice pour le moment.",
      number: "Devoir n°{{id}}",
      title: "Modifier le devoir",
    },
    parent: {
      pickChild: "Choisissez d'abord un enfant depuis le tableau de bord.",
    },
    student: { list: "Devoirs assignés" },
    submissions: {
      empty: "Aucune copie pour le moment.",
      failedLoad: "Impossible de charger les copies",
      failedSave: "Impossible d'enregistrer la correction",
      grading: "Résumé de la correction",
      homework: "Devoir n°{{id}}",
      late: "En retard",
      maxScore: "Note maximale",
      score: "Note",
      status: "Statut",
      submittedAt: "Rendu le",
      title: "Copies du devoir",
    },
    take: {
      answered: "Répondu :",
      backToHomeworks: "Retour aux devoirs",
      confirmLeave: "Voulez-vous quitter le devoir ?",
      doNotLeave: "Ne quittez pas la page pendant le devoir.",
      failedLoad: "Impossible de charger le devoir",
      failedSubmit: "Impossible d'envoyer le devoir",
      homework: "Devoir",
      noExercisesYet: "Aucun exercice pour le moment.",
      notFound: "Devoir introuvable.",
      passage: "Texte",
      previewModeNote:
        "Mode aperçu (les enseignants et administrateurs ne peuvent pas envoyer).",
      progress: "Progression",
      questionLabel: "Question {{num}}",
      questionNavigation: "Navigation entre les questions",
      submittedBody: "Vos réponses ont été envoyées à l'enseignant.",
      submittedTitle: "Envoyé",
    },
    teacher: {
      assignmentTarget: "Assigner à",
      assignToClass: "Classe",
      assignToStudent: "Élève",
      class: "Classe",
      confirmDelete: "Supprimer ce devoir ?",
      create: "Créer un devoir",
      edit: "Modifier",
      empty: "Aucun devoir pour le moment.",
      failedCreate: "Impossible de créer le devoir",
      failedDelete: "Impossible de supprimer le devoir",
      failedUpdate: "Impossible de mettre à jour le devoir",
      list: "Vos devoirs",
      noClasses: "Aucune classe trouvée.",
      noStudents: "Aucun élève trouvé.",
      publish: "Publier",
      selectClass: "Choisir une classe",
      selectStudent: "Choisir un élève",
      student: "Élève",
      submissions: "Copies",
      subtitle: "Créez, assignez et corrigez les devoirs.",
      unpublish: "Dépublier",
    },
  },
};

const arModules = {
  homeworks: {
    common: {
      add: "إضافة",
      adding: "جارٍ الإضافة...",
      config: "الإعدادات (JSON)",
      create: "إنشاء",
      creating: "جارٍ الإنشاء...",
      delete: "حذف",
      description: "الوصف",
      dueAt: "آخر أجل",
      edit: "تعديل",
      failedLoad: "تعذّر تحميل الواجبات",
      leave: "مغادرة",
      order: "الترتيب",
      points: "النقاط",
      preview: "معاينة",
      prompt: "التعليمة",
      save: "حفظ",
      saving: "جارٍ الحفظ...",
      status: "الحالة",
      submit: "إرسال",
      submitting: "جارٍ الإرسال...",
      title: "الواجبات",
      titleLabel: "العنوان",
      type: "النوع",
    },
    editor: {
      addExercise: "إضافة تمرين",
      confirmDeleteExercise: "هل تريد حذف هذا التمرين؟",
      details: "التفاصيل",
      exercises: "التمارين",
      failedAddExercise: "تعذّرت إضافة التمرين",
      failedDeleteExercise: "تعذّر حذف التمرين",
      failedLoad: "تعذّر تحميل الواجب",
      failedSave: "تعذّر حفظ الواجب",
      failedSaveExercise: "تعذّر حفظ التمرين",
      invalidJson: "إعدادات JSON غير صالحة.",
      noExercises: "لا توجد تمارين بعد.",
      number: "الواجب رقم {{id}}",
      title: "تعديل الواجب",
    },
    parent: { pickChild: "اختر طفلاً أولاً من لوحة التحكم." },
    student: { list: "الواجبات المسندة" },
    submissions: {
      empty: "لا توجد إجابات بعد.",
      failedLoad: "تعذّر تحميل الإجابات",
      failedSave: "تعذّر حفظ التصحيح",
      grading: "ملخّص التصحيح",
      homework: "الواجب رقم {{id}}",
      late: "متأخر",
      maxScore: "العلامة القصوى",
      score: "العلامة",
      status: "الحالة",
      submittedAt: "تاريخ الإرسال",
      title: "إجابات الواجب",
    },
    take: {
      answered: "تمّت الإجابة:",
      backToHomeworks: "العودة إلى الواجبات",
      confirmLeave: "هل تريد مغادرة الواجب؟",
      doNotLeave: "لا تغادر الصفحة أثناء الواجب.",
      failedLoad: "تعذّر تحميل الواجب",
      failedSubmit: "تعذّر إرسال الواجب",
      homework: "واجب",
      noExercisesYet: "لا توجد تمارين بعد.",
      notFound: "الواجب غير موجود.",
      passage: "النص",
      previewModeNote: "وضع المعاينة (لا يمكن للمعلّمين والمشرفين الإرسال).",
      progress: "التقدّم",
      questionLabel: "السؤال {{num}}",
      questionNavigation: "التنقّل بين الأسئلة",
      submittedBody: "تمّ إرسال إجاباتك إلى المعلّم.",
      submittedTitle: "تمّ الإرسال",
    },
    teacher: {
      assignmentTarget: "إسناد إلى",
      assignToClass: "قسم",
      assignToStudent: "تلميذ",
      class: "القسم",
      confirmDelete: "هل تريد حذف هذا الواجب؟",
      create: "إنشاء واجب",
      edit: "تعديل",
      empty: "لا توجد واجبات بعد.",
      failedCreate: "تعذّر إنشاء الواجب",
      failedDelete: "تعذّر حذف الواجب",
      failedUpdate: "تعذّر تحديث الواجب",
      list: "واجباتك",
      noClasses: "لا توجد أقسام.",
      noStudents: "لا يوجد تلاميذ.",
      publish: "نشر",
      selectClass: "اختر قسماً",
      selectStudent: "اختر تلميذاً",
      student: "التلميذ",
      submissions: "الإجابات",
      subtitle: "أنشئ الواجبات وأسندها وصحّحها.",
      unpublish: "إلغاء النشر",
    },
  },
};

// Deep merge for the blocks above.
function merge(a, b) {
  const out = { ...a };
  Object.entries(b).forEach(([key, value]) => {
    out[key] =
      value && typeof value === "object" && !Array.isArray(value)
        ? merge(a[key] || {}, value)
        : value;
  });
  return out;
}

const extraTranslations = {
  en,
  fr: merge(fr, frModules),
  ar: merge(ar, arModules),
};

export default extraTranslations;
